import ReactDOM from 'react-dom';
import { ReactElement, ReactPortal } from 'react';

export enum PortalType {
  Header = 'portal-header',
  Tooltip = 'portal-tooltip',
  Modal = 'portal-modal',
  Overlay = 'portal-overlay',
  BottomDrawer = 'portal-bottom-drawer',
  ToastNotification = 'portal-toast-notification',
}

export const renderPortal = (jsx: ReactElement, portalType: PortalType): ReactPortal => {
  const el = document.getElementById(portalType);
  if (el) {
    return ReactDOM.createPortal(jsx, el);
  } else {
    throw new Error(`No portal container of type ${portalType}`);
  }
};
